import React from "react";
import { Helmet } from 'react-helmet-async';
import '../Styles/ins_19.css';

function BlogPage() {

  const pageUrl = encodeURIComponent('https://outstandingworkplaces.co/worklife');
  const shareText = encodeURIComponent('Work-Life Balance Examples to Boost Employee Engagement!');

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?url=${pageUrl}&text=${shareText}`, '_blank', 'width=600,height=500');
  };

  const handleLinkedInShare = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${shareText}%20${pageUrl}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Work Life Balanace — Outstanding Workplaces</title>
        <meta property="og:title" content="Work Life Balanace — Outstanding Workplaces" />
        <meta property="og:description" content="Work-Life Balance Examples to Boost Employee Engagement" />
        <meta property="og:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778052541/i_18_hueuhz.jpg" />
        <meta property="og:url" content="https://outstandingworkplaces.co/worklife" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Work Life Balanace — Outstanding Workplaces" />
        <meta name="twitter:description" content="Work-Life Balance Examples to Boost Employee Engagement" />
        <meta name="twitter:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778052541/i_18_hueuhz.jpg" />
      </Helmet>

       <div className="sight_19_page_wrapper">
        <div className="sight_19_content_container">

          <div className="sight_19_section_one">

            <h1 className="sight_19_page_title">
             Why Employee Engagement Surveys Are Becoming a Retention Strategy in India
            </h1>

            <div className="sight_19_row">

              <div className="sight_19_left">
                <div className="sight_19_image_wrapper">
                  <img src="/sur.png" alt="Team meeting discussion" className="sight_19_blog_image" />
                </div>

                {/* SHARE SECTION */}
                <div className="sight_19_share_section">
                  <span className="sight_19_share_text">Share :</span>
                  <div className="sight_19_social_icons">

                    <img
                      src="/assets/Twitter_1.png"
                      className="sight_19_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleTwitterShare}
                      alt="Share on Twitter"
                    />

                    <img
                      src="/assets/LinkedIn_1.png"
                      className="sight_19_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleLinkedInShare}
                      alt="Share on LinkedIn"
                    />

                    <img
                      src="/assets/Facebook_1.png"
                      className="sight_19_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleFacebookShare}
                      alt="Share on Facebook"
                    />

                    <img
                      src="/assets/WhatsApp_1.png"
                      className="sight_19_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleWhatsAppShare}
                      alt="Share on WhatsApp"
                    />

                  </div>
                </div>

           <div className="sight_19_para_wrapper">
                  <h2 className="sight_19_para_title">
                    Employee engagement surveys are no longer just an annual HR activity. In today's changing workplace, they are becoming an important tool for understanding why employees stay, disengage, or consider leaving.
                  </h2>
                  <h2 className="sight_19_para_title">
                    Gallup's 2026 India data shows that only 23% of employees are engaged, while 59% are not engaged. This makes regular employee listening increasingly important for organizations.
                  </h2>
                  
                </div>

              </div>

              <div className="sight_19_right">
                <div className="sight_19_ad_card">
                  <img src="/assets/bc_1.png" className="sight_19_ad_bg" />
                  <div className="sight_19_ad_overlay"></div>
                  <img src="/assets/bg_1.png" className="sight_19_ad_badge" />

                  <div className="sight_19_ad_content">
                    <h2>
                      Earn the Outstanding <br />
                      <span>Workplaces Certification</span>
                    </h2>
                    <ul>
                      <li>Attract Top Talent</li>
                      <li>Boost Employee Engagement</li>
                      <li>Drive Culture-Led Growth</li>
                    </ul>
                    <button
                      className="sight_19_ad_btn"
                      onClick={() => window.location.href = '/nominate'}
                    >
                      Get Certificate
                    </button>
                  </div>
                </div>
              </div>

            </div>

            
          </div>

          <div className="sight_19_section">
            <div className="sight_19_topics">

             

              <div className="sight_19_topic_item">
                <h3 className="sight_19_topic_heading">Listen Before Employees Leave</h3>
                <ul className="sight_19_topic_list">
                  <li>
                    Employees rarely decide to leave overnight. Disengagement often starts with poor communication, lack of recognition, limited growth opportunities, burnout, or weak manager relationships.
                  </li>
                  <li>
                    Engagement surveys can help organizations identify these warning signs early.
                  </li>
                 
                </ul>
              </div>

              <div className="sight_19_topic_item">
                <h3 className="sight_19_topic_heading">Feedback Must Lead to Action</h3>
                <ul className="sight_19_topic_list">
                  <li>
                    Offering remote or hybrid work models enables employees to save commuting time and create a comfortable work environment.
                  </li>
                  
                </ul>
              </div>

              <div className="sight_19_topic_item">
                <h3 className="sight_19_topic_heading">Employees want to know:</h3>
                <ul className="sight_19_topic_list">
                  <li>
                   "We shared our feedback. What will change?”
                  </li>
                  <li>
                  Consistent listening combined with visible action can strengthen trust, workplace culture, and long-term retention.
                  </li>
                  
                </ul>
              </div>

              <div className="sight_19_topic_item">
                <h3 className="sight_19_topic_heading">Managers Matter</h3>
                <ul className="sight_19_topic_list">
                  <li>
                   Employees experience the organization largely through their day-to-day interactions with managers. Survey insights can help leaders identify teams that need better communication, recognition, coaching, or support.
                  </li>
                  <li>
                  Gallup's recent India research highlights the growing pressure on managers and the importance of continuous conversations rather than relying only on annual feedback cycles.
                  </li>
                  
                </ul>
              </div>

              <div className="sight_19_topic_item">
                <h3 className="sight_19_topic_heading">The Bottom Line</h3>
                <ul className="sight_19_topic_list">
                  <li>
                    Employee engagement surveys are becoming a retention strategy because organizations want to understand employee concerns before they become exit interviews.
                  </li>
                  
                 
                </ul>
              </div>

              <div className="sight_19_topic_item">
                <h3 className="sight_19_topic_heading">Listen. Analyze. Act. Communicate. Repeat.</h3>
                <ul className="sight_19_topic_list">
                  <li>
                    The organizations that turn employee feedback into meaningful action will be better positioned to build trust, strengthen engagement, and retain talent.
                  </li>
                 
                </ul>
              </div>

              <div className="sight_19_topic_item">
                <h3 className="sight_19_topic_heading">Key takeaway: Don't wait until employees leave to ask them what went wrong. Listen while they are still part of the journey.</h3>
                
              </div>

              

            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default BlogPage;